module.exports = __webpack_public_path__ + "static/media/layout2-img.e7c05c17.svg";